<template>
    <modal name="DocumentPdf" :draggable="false" :scrollable="true" :height="'auto'">
      <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
        <div class="modal-dialog  modal-xl">
          <div class="modal-content">
  
            <div class="modal-header">
              <button type="button" class="btn-close" @click.prevent="removeModals()" aria-label="Close">
                <!-- <span aria-hidden="true">&times;</span> -->
              </button>
            </div>
  
            <div class="modal-body">
                <iframe :src="pdfSrc" width="100%" height="600px"></iframe>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">Batal</button>
            </div>
  
          </div>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    name: "DocumentPdf",
    props: {
      documentId: { type: Number }
    },
    data() {
      return {
        pdfSrc:""
      }
    },
    methods: {
        removeModals() {
            this.$modal.hide('DocumentPdf');
        },
       
    },
    created() { },
    watch: {
        documentId: function (newVal) {
            var baseURI = this.$settings.endPointCeisa + "generate-pdf/"+newVal;
            this.pdfSrc = baseURI;
        },
    }
  }
  </script>
  
  <style></style>